import React from 'react';
import './App.css';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Results from './components/Results';
import Insurance from './components/Insurance';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Appointment from './components/Appointment';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Results />
        <Insurance />
        <FAQ />
        <Appointment />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
